var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"permission"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"wrap"},[_c('v-icon',{attrs:{"name":"lock","scale":"5"}}),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.msg))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }